import { errorHelpers, miscHelpers, routerHelpers } from '@approvalmax/utils';
import { domain } from 'modules/data';
import * as firstStart from 'modules/first-start';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { routingService } from 'services/routing';
import { getPath, Path } from 'urlBuilder';

export const useSignUpWithFinalizePageData = () => {
    const dispatch = useDispatch();
    const search = useLocation().search;
    const initialOAuthProvider = routerHelpers.getParamAsString(search, 'oauthProvider', '');
    const oAuthProvider = initialOAuthProvider ? initialOAuthProvider.toLowerCase() : undefined;

    useEffect(() => {
        if (miscHelpers.isEnumValue(domain.OAuthProvider, oAuthProvider)) {
            routingService.replaceToDefaultPath();

            switch (oAuthProvider) {
                case domain.OAuthProvider.Xero:
                case domain.OAuthProvider.QBooks:
                    dispatch(
                        firstStart.loadNewOrganisationSetup({
                            oauthProvider: oAuthProvider,
                            firstStart: true,
                        })
                    );
                    break;

                case domain.OAuthProvider.Google:
                case domain.OAuthProvider.Microsoft:
                    // https://localapp.amaxinternal.com:8000/signUpWith/finalize?oauthProvider=google
                    // show invites, what to do question, account creation wizard if needed
                    dispatch(firstStart.loadSsoAfterSignUpSetup());
                    break;

                default:
                    throw errorHelpers.assertNever(oAuthProvider);
            }
        } else {
            routingService.replace(getPath(Path.login));
        }
    }, [dispatch, oAuthProvider]);
};
